import React from 'react';
import { Menu } from '@mantine/core';

type Props = {
    options: Array<{
        label: string;
        icon: React.ReactNode;
        onClick: (row: any) => void;
        isShown?: boolean;
    }>;
    children: React.ReactNode;
    row: any;
};

function TableActions({ options, children, row }: Props) {
    return (
        <Menu width={200} shadow="md">
            <Menu.Target>{children}</Menu.Target>
            {(options.some(option => option.isShown) ||
                options.length <= 0) && (
                <Menu.Dropdown>
                    {options.length <= 0 ? (
                        <Menu.Item
                            disabled
                            className="capitalize justify-center text-center "
                        >
                            No options available
                        </Menu.Item>
                    ) : (
                        options.map(
                            option =>
                                option.isShown && (
                                    <Menu.Item
                                        key={option.label}
                                        leftSection={option.icon}
                                        onClick={() => option.onClick(row)}
                                        className="capitalize "
                                    >
                                        {option.label}
                                    </Menu.Item>
                                ),
                        )
                    )}
                </Menu.Dropdown>
            )}
        </Menu>
    );
}

export default TableActions;
